import * as React from "react";
import {FComponent} from "../../react/f-component";

import "./date-picker.scss";
import {Calendar} from "./calendar";
import * as ReactDOM from "react-dom";
import {isChildNode} from "../../utils/dom";
import {anyAction} from "../../utils/any-action";
import {parseDate} from "../../utils/date-object";
import {paddingLeft} from "../../utils/strings";

interface P {
    onChange;
    value;
}
interface S {
    showCalendar: boolean;
    typing: string;
}

export class DatePicker extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            // showCalendar: true,
            showCalendar: false,

            typing: null,
        };

        this.onUnmount(anyAction((e) => {
            // @ts-ignore
            if (isChildNode(e.target, ReactDOM.findDOMNode(this).querySelector(".calendar"))) {
                return;
            }

            return this.state.showCalendar && this.setState({showCalendar: false});
        }));
    }

    setTyping(typingValue) {
        if (typingValue === "") {
            this.props.onChange(null);
        } else {
            const date = parseDate(typingValue);
            if (date) {
                this.props.onChange(date);
            }
        }
        this.setState({typing: typingValue});
    }

    render() {
        const {showCalendar, typing} = this.state;
        const {value, onChange, ...props} = this.props;
        return (
            <div className="date-picker">
                <input
                    className="input"
                    placeholder="MM/DD/YYYY"
                    value={typing || (value == null ? "" : formatDate(value))}
                    onClick={() => {
                        setTimeout(() => this.setState({showCalendar: true}), 0)
                    }}
                    onChange={(e) => this.setTyping(e.target.value)}
                    onBlur={() => this.setState({typing: null,})}
                    {...props}
                />

                {showCalendar && (
                    <Calendar
                        className="calendar"
                        selectedDate={value}
                        onChange={(value) => {
                            if (showCalendar) {
                                this.setState({showCalendar: false});
                            }
                            onChange(value);
                        }}
                        close={()=>{this.setState({showCalendar: false});}}
                    />
                )}

            </div>
        );
    }
}

const formatDate = (date) => date && `${paddingLeft(date.month)}/${paddingLeft(date.day)}/${date.year}`;


const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
